/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartridgeCreateBookingMutationVariables = {|
  spaceId?: ?string,
  category?: ?string,
  riders?: ?number,
  dates?: ?any,
  riderRef?: ?string,
  lang?: ?string,
|};
export type cartridgeCreateBookingMutationResponse = {|
  +createNewBooking: ?{|
    +frontURL: ?string
  |}
|};
export type cartridgeCreateBookingMutation = {|
  variables: cartridgeCreateBookingMutationVariables,
  response: cartridgeCreateBookingMutationResponse,
|};
*/


/*
mutation cartridgeCreateBookingMutation(
  $spaceId: String
  $category: String
  $riders: Int
  $dates: JSONObject
  $riderRef: String
  $lang: String
) {
  createNewBooking(spaceId: $spaceId, category: $category, riders: $riders, dates: $dates, riderRef: $riderRef) {
    frontURL(lang: $lang)
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "riderRef"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "riders"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "category",
    "variableName": "category"
  },
  {
    "kind": "Variable",
    "name": "dates",
    "variableName": "dates"
  },
  {
    "kind": "Variable",
    "name": "riderRef",
    "variableName": "riderRef"
  },
  {
    "kind": "Variable",
    "name": "riders",
    "variableName": "riders"
  },
  {
    "kind": "Variable",
    "name": "spaceId",
    "variableName": "spaceId"
  }
],
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "lang",
      "variableName": "lang"
    }
  ],
  "kind": "ScalarField",
  "name": "frontURL",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cartridgeCreateBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Booking",
        "kind": "LinkedField",
        "name": "createNewBooking",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "cartridgeCreateBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Booking",
        "kind": "LinkedField",
        "name": "createNewBooking",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c830cce7d46133899b04b304ec7b1a11",
    "id": null,
    "metadata": {},
    "name": "cartridgeCreateBookingMutation",
    "operationKind": "mutation",
    "text": "mutation cartridgeCreateBookingMutation(\n  $spaceId: String\n  $category: String\n  $riders: Int\n  $dates: JSONObject\n  $riderRef: String\n  $lang: String\n) {\n  createNewBooking(spaceId: $spaceId, category: $category, riders: $riders, dates: $dates, riderRef: $riderRef) {\n    frontURL(lang: $lang)\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71e7f4b1d39ca50846815e6e13b5990b';

module.exports = node;
